/**
 * Enrforce lock page: countdown, segment-display word animation, password reveal.
 * Custom element <enf24-lock>, no dependencies. Safe to load more than once.
 *
 * Reads from the element's data attributes (set by sections/enf24-lock.liquid):
 *   data-start        ISO 8601 with a UTC offset, e.g. 2026-10-11T00:00:00-06:00
 *   data-words        JSON array of the words shown one at a time, e.g. ["SOMETHING","BIG","IS","COMING..."]
 *   data-title-zero   text that replaces the countdown title once it reaches zero
 *
 * The word display
 *   A row of segment-display cells (nine, or as many as the longest word needs).
 *   Every cell always shows its unlit segments. '~' is the font's all-segments glyph,
 *   '!' a blank cell, '.' the decimal point. Trailing dots in a word use the decimal
 *   points and light up one at a time.
 *   In:   cells light left to right, each running through wrong patterns before it locks.
 *   Hold: now and then one cell drops out or shows a wrong pattern for a step.
 *   Out:  cells go dark right to left, each throwing one last wrong pattern.
 *   Everything moves in 60ms steps. With prefers-reduced-motion the words simply swap.
 */
(function () {
  if (window.customElements.get('enf24-lock')) return;

  var STEP = 60, TYPE = 70, SCRAMBLE = 180, DOT = 280, DEL = 40, DEL_FLASH = 60, GAP = 220;
  var HOLD_LAST = 3800;                                  // the final word stays up longest
  var CHARS = 'ABCDEFGHJKLMNPRSTUVXYZ0123456789';         // source of the "wrong" segment patterns
  var UNITS = ['Days', 'Hrs', 'Min', 'Sec'];

  function rnd(seed) { var x = Math.sin(seed * 127.1 + 11.3) * 43758.5453; return x - Math.floor(x); }
  function pad(n) { return String(n).padStart(2, '0'); }

  class Enf24Lock extends HTMLElement {
    connectedCallback() {
      this.reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.setupClock();
      //this.setupPassword();
      //this.setupWord();
    }

    disconnectedCallback() {
      window.clearInterval(this.clockTimer);
      window.clearTimeout(this.swapTimer);
      window.cancelAnimationFrame(this.raf);
    }

    /* ---------------- countdown ---------------- */
    setupClock() {
      var self = this;
      this.start = Date.parse(this.dataset.start);
      this.sets = [];
      Array.prototype.forEach.call(this.querySelectorAll('[data-enf24l-digits]'), function (digits) {
        var vals = [];
        digits.textContent = '';
        UNITS.forEach(function (label, i) {
          var unit = document.createElement('div'); unit.className = 'enf24l__unit';
          var num = document.createElement('div'); num.className = 'enf24l__num';
          var ghost = document.createElement('span'); ghost.className = 'enf24l__ghost'; ghost.setAttribute('aria-hidden', 'true'); ghost.textContent = '88';
          var val = document.createElement('span'); val.className = 'enf24l__val';
          var lab = document.createElement('div'); lab.className = 'enf24l__unit-label enf24l__label'; lab.textContent = label;
          num.appendChild(ghost); num.appendChild(val); unit.appendChild(num); unit.appendChild(lab); digits.appendChild(unit);
          vals.push(val);
          if (i < UNITS.length - 1) {
            var colon = document.createElement('div'); colon.className = 'enf24l__colon'; colon.setAttribute('aria-hidden', 'true'); colon.textContent = ':';
            digits.appendChild(colon);
          }
        });
        self.sets.push(vals);
      });
      if (isNaN(this.start)) {
        console.warn('[enf24-lock] Start time is missing or not ISO 8601 with an offset:', this.dataset.start);
        return;
      }
      this.tickClock = this.tickClock.bind(this);
      this.tickClock();
      this.clockTimer = window.setInterval(this.tickClock, 1000);
    }

    tickClock() {
      var s = Math.max(0, Math.floor((this.start - Date.now()) / 1000));
      var parts = [Math.floor(s / 86400), Math.floor((s % 86400) / 3600), Math.floor((s % 3600) / 60), s % 60];
      this.sets.forEach(function (vals) { parts.forEach(function (v, i) { vals[i].textContent = pad(v); }); });
      if (s === 0 && !this.zero) {
        this.zero = true;
        this.dataset.state = 'zero';
        var title = this.dataset.titleZero;
        if (title) Array.prototype.forEach.call(this.querySelectorAll('[data-enf24l-title]'), function (el) { el.textContent = title; });
        window.clearInterval(this.clockTimer);
      }
    }

    /* ---------------- password reveal ---------------- */
    setupPassword() {
      //window.location.href = '/account';
      /*
      var pw = this.querySelector('[data-enf24l-pw]');
      if (!pw) return;
      var toggle = pw.querySelector('[data-enf24l-pw-toggle]'), input = pw.querySelector('input[type="password"]');
      function set(open, focus) {
        pw.classList.toggle('is-open', open);
        if (toggle) toggle.setAttribute('aria-expanded', open);
        if (open && focus && input) input.focus();
      }
      if (pw.querySelector('[data-enf24l-pw-error]')) set(true, true);          // wrong password: reopen the form
      if (toggle) toggle.addEventListener('click', function () { set(!pw.classList.contains('is-open'), true); });
      */
    }
  }

  window.customElements.define('enf24-lock', Enf24Lock);
})();
